const chatgptButtonLayoutAdjuster = (() => {
    const layoutOverrides = {
      'de-DE': { maxWidth: '200px', left: '275px' },
      'en-GB': { maxWidth: '140px', left: '215px' },
      'en-US': { maxWidth: '140px', left: '215px' },
      'fr-FR': { maxWidth: '205px', left: '280px' },
      'es-419': { maxWidth: '210px', left: '285px' },
      'it-IT': { maxWidth: '150px', left: '230px' },
      'pt-BR': { maxWidth: '200px', left: '280px' },
      'ja-JP': { maxWidth: '160px', left: '238px' },
      'zh-CN': { maxWidth: '95px',  left: '170px' }
    };

    const mobileOverrides = {
      'de-DE': { maxWidth: '185px', left: '150px' },
      'en-GB': { maxWidth: '135px', left: '120px' },
      'en-US': { maxWidth: '135px', left: '120px' },
      'fr-FR': { maxWidth: '185px', left: '145px' },
      'es-419': { maxWidth: '180px', left: '155px' },
      'it-IT': { maxWidth: '140px', left: '115px' },
      'pt-BR': { maxWidth: '180px', left: '145px' },
      'ja-JP': { maxWidth: '150px', left: '135px' },
      'zh-CN': { maxWidth: '90px',  left: '110px' }
    };

    let lastWidthCategory = getWidthCategory();
  let resizeListener = null;
  let throttleTimeout = null;
  const throttleDelay = 100;

  function getWidthCategory() {
    const w = window.innerWidth;
    return w <= 480 ? 'compact' : w <= 719 ? 'mobile' : 'desktop';
  }

  const getLocale = () => {
    return getLanguage(); // assumes globally available
  };

  const applyChatgptButtonLayout = () => {
    const labelTextAttachList = document.querySelectorAll('.chatgptbox-icon-left .label-text-attach');
    const secondButtonList = document.querySelectorAll('.chatgptbox-icon-second-left');
    const firstButton = document.getElementById('chatgptbox-icon-left');

    if (!labelTextAttachList.length || !secondButtonList.length || !firstButton) return;

    const locale = getLocale();
    const isMobile = window.innerWidth <= 719;

    const layout = isMobile
      ? (mobileOverrides[locale] || mobileOverrides['en-US'])
      : (layoutOverrides[locale] || layoutOverrides['en-US']);

    const computedLeft = window.getComputedStyle(firstButton).left;
    const baseLeftPx = parseInt(computedLeft || '0', 10);
    const overrideLeftPx = parseInt(layout.left || '0', 10);
    const combinedLeft = (baseLeftPx + overrideLeftPx) + 'px';

    labelTextAttachList.forEach(label => {
      label.style.maxWidth = layout.maxWidth;
    });

    secondButtonList.forEach(button => {
      button.style.left = combinedLeft;
    });
  };

  const applyIfWidthChanged = () => {
    const currentCategory = getWidthCategory();
    if (currentCategory !== lastWidthCategory) {
      lastWidthCategory = currentCategory;
      applyChatgptButtonLayout();
    }
  };

  const throttledResizeHandler = () => {
    if (throttleTimeout) return;
    throttleTimeout = setTimeout(() => {
      applyIfWidthChanged();
      throttleTimeout = null;
    }, throttleDelay);
  };

  const init = () => {
    applyChatgptButtonLayout();
    resizeListener = throttledResizeHandler;
    window.addEventListener('resize', resizeListener);
  };

  const unload = () => {
    if (resizeListener) {
      window.removeEventListener('resize', resizeListener);
      resizeListener = null;
    }
    clearTimeout(throttleTimeout);
    throttleTimeout = null;
  };

  return {
    init,
    unload
  };
})();

export default chatgptButtonLayoutAdjuster;